export abstract class TokenStore {
  abstract getToken(): string | null;
  abstract setToken(token: string): void;
  abstract clearToken(): void;
}

export class HybridTokenStore extends TokenStore {
  constructor(
    private readonly primaryStore: TokenStore,
    private readonly fallbackStore: TokenStore
  ) {
    super();
  }

  getToken(): string | null {
    const primary = this.primaryStore.getToken();
    if (primary) {
      return primary;
    }

    const fallback = this.fallbackStore.getToken();
    if (fallback) {
      this.primaryStore.setToken(fallback);
    }

    return fallback;
  }

  setToken(token: string): void {
    // Only the in-memory primary store is written intentionally.
    // The session fallback store is read-only by design; new tokens are not persisted there.
    this.primaryStore.setToken(token);
  }

  clearToken(): void {
    this.primaryStore.clearToken();
    this.fallbackStore.clearToken();
  }
}
